﻿import {writable} from "svelte/store";

export const importTokenStore = writable<string>(null);